/* unplugin-vue-components disabled */import { render } from "./menu-point-line.vue?vue&type=template&id=306cd020"
import script from "./menu-point-line.vue?vue&type=script&lang=js"
export * from "./menu-point-line.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__